import { eventQBus } from '@otto-ec/global-resources/event-q-bus';
import { BaseComponent2 } from '../../_common/client/base-component2';
import { PriceChangeEvent } from '../../price/client/price.component';

export class DelayedPaymentComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_delayed_payment';
    private readonly priceElementSelector = '.pdp_delayed_payment__price';

    public override async init(): Promise<void> {
        eventQBus.on('ft5.variation.price.change', this.variationChangeListener.bind(this));
    }

    private variationChangeListener(event: PriceChangeEvent): void {
        const newPrice = (event.newPriceCents * 0.035) / 100.0;

        if (this.priceElement) {
            this.priceElement.innerHTML = newPrice.toFixed(2).toString().replace('.', ',');
        }
    }

    private get priceElement(): HTMLElement | null | undefined {
        return this.rootElement?.querySelector(this.priceElementSelector);
    }
}
